import React from "react";
import { Box, Typography } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { formatDuration } from "bundles/Internal/components/common/FloatingTimer";

export default function TimerHandle({ onOpen, isRunning, elapsedTime }) {
  return (
    <Box
      onClick={onOpen}
      aria-label="Open timer widget"
      sx={{
        position: "fixed",
        right: 0,
        top: 96,
        zIndex: 1300,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        borderRadius: "12px 0 0 12px",
        bgcolor: "hsl(150 38% 17%)",
        py: 1.5,
        pl: 1,
        pr: 0.75,
        cursor: "pointer",
        transition: "padding-right 0.2s ease",
        "&:hover": { pr: 1.25 },
        "@keyframes pop-in": {
          from: { transform: "scale(0.6)", opacity: 0 },
          to: { transform: "scale(1)", opacity: 1 },
        },
        animation: "pop-in 0.22s cubic-bezier(0.22, 1, 0.36, 1)",
      }}
    >
      <ChevronLeft sx={{ color: "white", fontSize: 16 }} />
      {isRunning ? (
        <>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              bgcolor: "hsl(145, 60%, 45%)",
              "@keyframes pulse-dot": {
                "0%, 100%": { opacity: 1, transform: "scale(1)" },
                "50%": { opacity: 0.55, transform: "scale(0.85)" },
              },
              animation: "pulse-dot 1.4s ease-in-out infinite",
            }}
          />
          <Typography
            sx={{
              fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
              fontSize: 11,
              color: "white",
              writingMode: "vertical-rl",
              letterSpacing: -0.5,
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {formatDuration(elapsedTime)}
          </Typography>
        </>
      ) : (
        <Typography
          sx={{
            fontSize: 10,
            fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
            color: "white",
            writingMode: "vertical-rl",
            textTransform: "uppercase",
            letterSpacing: 2,
          }}
        >
          Timer
        </Typography>
      )}
    </Box>
  );
}
